import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartLine } from './useGetChartLine'
import { ChartLineContent } from './ChartLineContent'

export const ChartLineComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartLine(id, tileFilterSelections)

  return (
    <ChartLineContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartLineComponentLoading() {
  return 'Loading...'
}
